<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.COMMON.SELECT_PRODUCTS' | translate }}</h2>
<mat-dialog-content *ngIf="userData$ | async as userData">
  <inventory-ui-item-search-multi-select-filter
    [config]="{ partnerId: userData.partnerId, marketId: userData.marketId, filters: itemSelectorFilters }"
    [selectedItems]="selectedItems"
    (selectionChange)="onSelectionChange($event)"
  ></inventory-ui-item-search-multi-select-filter>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button (click)="saveItemSelection()" [disabled]="savingFilter$ | async" color="primary" mat-raised-button>
    {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
  </button>
</mat-dialog-actions>
